import { render, staticRenderFns } from "./EditGroupPapers.vue?vue&type=template&id=f218eae8&scoped=true"
import script from "./EditGroupPapers.vue?vue&type=script&lang=js"
export * from "./EditGroupPapers.vue?vue&type=script&lang=js"
import style0 from "./EditGroupPapers.vue?vue&type=style&index=0&id=f218eae8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f218eae8",
  null
  
)

export default component.exports